import { render, staticRenderFns } from "./edit-vessel.vue?vue&type=template&id=4e837fd7"
import script from "./edit-vessel.vue?vue&type=script&lang=js"
export * from "./edit-vessel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports